<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div class="big_tit">
        {{ $t('home.team') }}
      </div>
    </div>
		
    <div
      class="block_div my_team_wrap"
      style="margin-top: 60px;"
    >
      <div style="display: flex;align-items: flex-start;gap: 12px;padding-bottom: 10px;border-bottom: 1px solid #edf2fa;">
        <div style="width: 56px;height: 56px;border-radius: 50%;overflow: hidden;border: 2px solid #d7e4f8;">
          <img
            style="width: 100%;height: 100%;-o-object-fit: cover;object-fit: cover;"
            :src="user_info.user_icon"
          >
        </div>
        <div style="flex: 1;min-width: 0;">
          <div style="display: flex;align-items: center;justify-content: space-between;gap: 8px;margin-bottom: 6px;">
            <p style="flex: 1;min-width: 0;font-size: 16px;font-weight: 700;line-height: 1.2;margin-bottom: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;  color: #1a2742;">
              {{ user_info.username }}
            </p>
            <div
              style="height: 32px;max-width: 56%;padding: 0 8px;border-radius: 8px;border: 1px solid rgba(80, 233, 216, .65);background: rgba(69, 238, 213, .12);color: #7ff6e8;
    font-size: 11px;font-weight: 700;display: inline-flex;align-items: center;
    justify-content: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;border: 1px solid #cfe0fa;
    background: #f3f8ff;
    color: #2e78ff;"
            >
              {{ user_info.vip_name }}
            </div>
          </div>
          <div style="display: flex;align-items: center;justify-content: space-between;gap: 8px;margin-bottom: 6px;">
            <p style="color:#607798;flex: 1;min-width: 0;font-size: 11px;line-height: 1.2;margin-bottom: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
              {{ $t('user.invite_code') }}:{{ user_info.invite_code }}
            </p>
            <div
              style="height: 32px;max-width: 56%;padding: 0 8px;border-radius: 8px;border: 1px solid rgba(80, 233, 216, .65);background: rgba(69, 238, 213, .12);color: #7ff6e8;
					font-size: 11px;font-weight: 700;display: inline-flex;align-items: center;
					justify-content: center;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;border: 1px solid #cfe0fa;
					background: #f3f8ff;
					color: #607798;"
              @click="copys(user_info.invite_code)"
            >
              <img
                class="copy_img"
                src="../img/user/copy.png"
                style="width: 14px;height: 14px;filter: invert(42%) sepia(95%) saturate(1998%) hue-rotate(203deg) brightness(101%) contrast(100%);"
              >
              <em
                data-v-584164ec=""
                style="font-style: normal;font-size: 14px;font-weight: 700;line-height: 1;"
              >Copy</em>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;align-items: center;justify-content: space-between;gap: 8px;margin-bottom: 6px;">
        <p style="color: #607798;flex: 1;min-width: 0;font-size: 14px;line-height: 1.2;margin-bottom: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
          {{ $t('team.inviteLink') }}{{ user_info.share_link }}
        </p>
        <div
          style="height: 32px;max-width: 56%;padding: 0 8px;border-radius: 8px;border: 1px solid rgba(80, 233, 216, .65);background: rgba(69, 238, 213, .12);color: #7ff6e8;font-size: 11px;font-weight: 700;display: inline-flex;align-items: center;
			justify-content: center;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;border: 1px solid #cfe0fa;
			background: #f3f8ff;
			color: #607798;"
          @click="copys(user_info.share_link)"
        >
          <img
            class="copy_img"
            src="../img/user/copy.png"
            style="width: 14px;height: 14px;filter: invert(42%) sepia(95%) saturate(1998%) hue-rotate(203deg) brightness(101%) contrast(100%);"
          >
          <em
            data-v-584164ec=""
            style="font-style: normal;font-size: 14px;font-weight: 700;line-height: 1;"
          >Copy</em>
        </div>
      </div>
      <div style="margin-top: 12px;padding-top: 12px;border-top: 1px solid #edf2fa;">
        <p style="color: #7d8ca4;font-size: 12px;margin-bottom: 4px;">
          {{ $t('team.totalRevenue') }}
        </p>
        <h2 style="color: #1e7bff;font-size: 24px;font-weight: 800;line-height: 1;margin-bottom: 12px;">
          {{ common.currency_symbol_basic() }}{{ common.precision_basic(report.income) }}
        </h2>
        <div style="display: grid;grid-template-columns: 1fr 1fr;gap: 8px;margin-bottom: 10px;">
          <div style="border-radius: 7px;padding: 7px;background: #f7faff;border: 1px solid #e5eefb">
            <p style="color: #7486a2;font-size: 12px;margin-bottom:10px">
              {{ $t('team.today') }}
            </p>
            <strong style="color: #1a2742;font-size: 16px;">
              {{ common.currency_symbol_basic() }}{{ common.precision_basic(report.income_to) }}
            </strong>
          </div>
          <div style="border-radius: 7px;padding: 7px;background: #f7faff;border: 1px solid #e5eefb">
            <p style="color: #7486a2;font-size: 12px;margin-bottom:10px">
              {{ $t('team.yesterday') }}
            </p>
            <strong style="color: #1a2742;font-size: 16px;">
              {{ common.currency_symbol_basic() }}{{ common.precision_basic(report.income_ye) }}
            </strong>
          </div>
        </div>
      </div>
      <div style="display: grid;grid-template-columns: repeat(4, 1fr);gap: 8px;">
        <div style="background: #f7faff;border: 1px solid #e5eefb;border-radius: 7px;padding: 8px 4px;text-align: center;">
          <div style="margin-bottom: 4px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;color: #7486a2;font-size: 12px;">
            {{ $t('team.total') }}
          </div>
          <strong style="margin-bottom: 4px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 14px;color: #1e7bff;">
            {{ report.add_count }}
          </strong>
        </div>
        <div style="background: #f7faff;border: 1px solid #e5eefb;border-radius: 7px;padding: 8px 4px;text-align: center;">
          <div style="margin-bottom: 4px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;color: #7486a2;font-size: 12px;">
            Level 1
          </div>
          <strong style="margin-bottom: 4px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 14px;color: #1e7bff;">
            {{ report.one }}
          </strong>
        </div>
        <div style="background: #f7faff;border: 1px solid #e5eefb;border-radius: 7px;padding: 8px 4px;text-align: center;">
          <div style="margin-bottom: 4px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;color: #7486a2;font-size: 12px;">
            Level 2
          </div>
          <strong style="margin-bottom: 4px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 14px;color: #1e7bff;">
            {{ report.two }}
          </strong>
        </div>
        <div style="background: #f7faff;border: 1px solid #e5eefb;border-radius: 7px;padding: 8px 4px;text-align: center;">
          <div style="margin-bottom: 4px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;color: #7486a2;font-size: 12px;">
            Level 3
          </div>
          <strong style="margin-bottom: 4px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;font-size: 14px;color: #1e7bff;">
            {{ report.there }}
          </strong>
        </div>
      </div>
    </div>
    <div style="height: 36px;background-color: #f7faff;width: 94%;margin-left: 3%;border-radius: 14px;display: flex;padding: 0 5px;"> 
      <div
        :class="actives == '1' ? 'active' : ''"
        style="line-height: 24px;font-weight: 600;text-align: center;border-radius: 10px;;flex: 1 1 0%;;height:24px;margin-top:6px;;color:#6d7f99;transition-property: all;transition-timing-function: cubic-bezier(.4, 0, .2, 1);transition-duration: .15s;"
        @click="dianji(1)"
      >
        Level 1
      </div>
      <div
        :class="actives == '2' ? 'active' : ''"
        style="line-height: 24px;font-weight: 600;text-align: center;border-radius: 10px;height:24px;margin-top:6px;flex: 1 1 0%;color:#6d7f99;transition-property: all;transition-timing-function: cubic-bezier(.4, 0, .2, 1);transition-duration: .15s;"
        @click="dianji(2)"
      >
        Level 2
      </div>
      <div
        :class="actives == '3' ? 'active' : ''"
        style="line-height: 24px;font-weight: 600;text-align: center;border-radius: 10px;flex: 1 1 0%;height:24px;margin-top:6px;;color:#6d7f99;transition-property: all;transition-timing-function: cubic-bezier(.4, 0, .2, 1);transition-duration: .15s;"
        @click="dianji(3)"
      >
        Level 3
      </div>
    </div>
    <div style="margin-top: 10px;height: 126px;background-color: rgb(30 41 59);width: 94%;margin-left: 3%;border-radius: 14px;display: flex;padding: 0 10px;">
      <div style="text-align: center;padding: 10px;background-color: #4c1d9533;border-radius: 10px;flex: 1 1 0%;margin-top: 15px;height: 96px;">
        <div style="padding-top: 8px;margin:0 auto;background-color: #4c1d9566;border-radius: 7px;height: 28px;width: 28px;align-items: center;justify-content: center;">
          <svg
            style="font-size: 12px;line-height: 18px;color:rgb(167 139 250 /1);display:inline-block;height: 12px;"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="chart-line"
            class="svg-inline--fa fa-chart-line text-violet-400 text-sm"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          ><path
            fill="currentColor"
            d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
          /></svg>
        </div>
        <div style="color:rgb(148 163 184);font-size: 10px;line-height: 24px;height: 24px"> 
          {{ $t('utils.yjbili') }}
        </div>
        <div style="color:rgb(139 92 246);font-size: 10px;line-height: 24px;height: 24px">
          {{ teams.yjbili }}%
        </div>
      </div>
      <div style="text-align: center;padding: 10px;background-color: #0f172a4d;border-radius: 10px;flex: 1 1 0%;margin-top: 15px;height: 96px;">
        <div style="padding-top: 8px;margin:0 auto;background-color: #4c1d9566;border-radius: 7px;height: 28px;width: 28px;align-items: center;justify-content: center;">
          <svg
            aria-hidden="true"
            style="font-size: 12px;line-height: 18px;color:#fff;display:inline-block;height: 12px;"
            focusable="false"
            data-prefix="fas"
            data-icon="users"
            class="svg-inline--fa fa-users text-violet-400 text-sm"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 512"
          ><path
            fill="currentColor"
            d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"
          /></svg>
        </div>
        <div style="color:rgb(148 163 184);font-size: 10px;line-height: 24px;height: 24px"> 
          {{ $t('team.total') }}
        </div>
        <div style="color:#fff;font-size: 10px;line-height: 24px;height: 24px">
          {{ teams.count }}
        </div>
      </div>
      <div style="text-align: center;padding: 10px;background-color: #701a7533;border-radius: 10px;flex: 1 1 0%;margin-top: 15px;height: 96px;">
        <div style="padding-top: 8px;margin:0 auto;background-color: #4c1d9566;border-radius: 7px;height: 28px;width: 28px;align-items: center;justify-content: center;">
          <svg
            style="font-size: 12px;line-height: 18px;color:rgb(232 121 249/1);display:inline-block;height: 12px;"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="coins"
            class="svg-inline--fa fa-coins text-fuchsia-400 text-sm"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2c0 0 0 0 0 0s0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4l0 3.4 0 5.7 0 26.3zm32 0l0-32 0-25.9c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5l0 35.4c0 44.2-86 80-192 80S0 476.2 0 432l0-35.4c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
            />
          </svg>
        </div>
        <div style="color:rgb(148 163 184);font-size: 10px;line-height: 24px;height: 24px"> 
          {{ $t('utils.yj') }}
        </div>
        <div style="color:#fff;font-size: 10px;line-height: 24px;height: 24px">
          {{ common.currency_symbol_basic() }}{{ teams.yongjin }}
        </div>
      </div>
    </div>
    <div
      class="block_div team_list_wrap"
      style="border-radius: 14px;margin-top: 10px;margin-bottom: 100px;"
    >
      <div
        class="team_list_title"
        style="color:#000"
      >
        <svg
          aria-hidden="true"
          style="font-size: 12px;line-height: 18px;color:#000;display:inline-block;height: 12px;"
          focusable="false"
          data-prefix="fas"
          data-icon="users"
          class="svg-inline--fa fa-users text-violet-400 text-sm"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
        ><path
          fill="currentColor"
          d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z"
        /></svg>
        {{ $t('team.teamList') }} Level {{ actives }}
      </div>
      <div
        class="list_item"
        style=""
      >
        <van-list
          v-model="loading"
          offset="0"
          :finished="finished"
          @load="onLoad"
        >
          <div
            v-for="(item,index) in list"
            class="item"
            style="background: linear-gradient(to right bottom, rgb(109, 40, 217), rgb(217, 70, 239), rgb(244, 114, 182));;border-top:1px solid #ccc;border-radius:14px;"
          >
            <div class="flex_center">
              <p style="color: #fff;">
                {{ item.act_time }}
              </p>
              <!-- <p style="color: #fff;">
								Level {{item.level}}
							</p> -->
              <p style="padding:0 5px;color: #fff;background: linear-gradient(to right, #6d28d9, #d946ef);text-align: center;height:20px;line-height: 20px;border-radius:5px;font-size: 12px">
                {{ item.vip_name }}
              </p>
              <!-- <p v-if="item.level==1" class="color_red">{{$t('team.direct')}}</p>
							<p v-if="item.level!=1">{{$t('team.indirect')}}</p> -->
            </div>
            <div class="flex_center">
              <p style="color: #fff;">
                ID:{{ item.id }}
              </p>
              <p style="color: #fff;">
                {{ common.currency_symbol_basic()+common.precision_basic(item.recharge_sum) }}
              </p>
            </div>
            <div class="flex_center">
              <p style="color: #fff;">
                {{ $t('team.username') }}:{{ item.username }}
              </p>
              <p style="color: #fff;">
                {{ $t('team.totalRecharge') }}
              </p>
            </div>
          </div>
        </van-list>
        <van-empty
          v-if="empty"
          :description="$t('utils.noData')"
        />
      </div>
    </div>
    <van-popup
      v-model:show="show_share"
      position="bottom"
      closeable
      close-icon-position="top-left"
    >
      <div class="share_wrap">
        <div class="share">
          <div class="invite_friend">
            <p />
          </div>
          <div class="share_code">
            <img :src="user_info.share_code">
          </div>
          <div class="invite_code flex_center">
            <p>{{ $t('user.invite_code') }}:</p>
            <p
              v-clipboard="()=>user_info.invite_code"
              v-clipboard:success="copy"
              class="code_link"
            >
              {{ user_info.invite_code }}
              <img
                class="copy_img"
                src="../img/user/copy.png"
              >
            </p>
          </div>
          <div class="invite_code flex_center">
            <p>{{ $t('team.inviteLink') }}</p>
            <div class="flex_center invite_link">
              <p
                v-clipboard="()=>user_info.share_link"
                v-clipboard:success="copy"
                class="code_link"
              >
                {{ user_info.share_link }}
              </p>
              <img
                class="copy_img"
                src="../img/user/copy.png"
              >
            </div>
          </div>
        </div>
      </div>
    </van-popup> 
    <!-- 客服图标 -->
    <!-- <div class="kefu share_btn" @click="show_share = true;">
			<img class="kefu_img" src="../img/user/share.png">
		</div> -->
  </div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch'
	import Clipboard from "v-clipboard";
	import {
		Icon,
		List,
		Empty,
		Popup
	} from "vant";
import bsHeader from '../../components/bsHeader.vue';
	Vue.use(Icon).use(Clipboard).use(List).use(Empty).use(Popup);
	export default {
		name: "Team",
		data() {
			return {
				user_info: [],
				report: {
					"direct_count": 0,
					"indirect_count": 0,
					"income": 0,
					"income_to": 0,
					"income_ye": 0,
					"add_count": 0,
					"add_count_to": 0,
					"add_count_ye": 0
				},
				show_share: false,
				actives:1,
				empty: false,
				loading: false,
				finished: false,
				list: [],
				teams:[],
				page: 1,
				listRows: 8
			};
		},
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#0F6EFF');
				plus.navigator.setStatusBarStyle('light');
			}
			this.$parent.footer('team');
		},
		mounted() {
			this.start();
		},
		methods: {
			async copys(e) {
			      try {
			        // Use navigator.clipboard.writeText to copy text
			        await navigator.clipboard.writeText(e);
			
					this.$toast(this.$t('recharge.copySuccess'));
			      } catch (error) {
			        console.error("Failed to copy text: ", error);
					this.$toast("Replication failed");
			      }
			    },
			copy() {
				this.$toast(this.$t('recharge.copySuccess'));
			},dianji(e){
				this.actives=e;
				this.page=1;
				this.list=[];
				this.myteam();
				Fetch('/user/teamList', {
					page: this.page,
					listRows: this.listRows,
					level:e
				}).then(r => {
					if (r.data.length == 0) {
						this.empty = true;
					}else{
						this.empty = false;
					}
					var list = r.data.list;
					
					for (var i = 0; i < r.data.length; i++) {
						this.list.push(list[i]);
					}
					if (this.list.length >= r.data.length) {
						this.finished = true;
						return;
					}
					this.page = this.page + 1;
					this.loading = false;
					
				});
			},myteam(){
				Fetch('/user/myTeams', {
					level: this.actives,
				}).then((r) => {
					this.teams=r.data;
				});
			},
			start() {
				this.myteam();
				Fetch('/user/myTeam').then((r) => {
					this.user_info = r.data.user_info;
					this.report = r.data.report;
					this.rate = 100;
				});
				
			},
			onLoad() {
				Fetch('/user/teamList', {
					page: this.page,
					listRows: this.listRows,
					level:this.actives
				}).then(r => {
					if (r.data.length == 0) {
						this.empty = true;
					}else{
						this.empty = false;
					}
					
					for (var i = 0; i < r.data.list.length; i++) {
						this.list.push(r.data.list[i]);
					}
					if (this.list.length >= r.data.length) {
						this.finished = true;
						return;
					}
					this.page = this.page + 1;
					this.loading = false;
					
				});
			},
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap {
		height:100%;
		min-height: 100vh;
		padding-bottom: 60px;
		background: #000000;
	}
	.red_top_bg {
		position: fixed;
		top: 0;
		z-index: 10;
		box-shadow:unset;
		.big_tit{
			left: 50%;
			transform: translateX(-50%);
		}
	}
	.active{
		background: linear-gradient(135deg, #2e78ff, #4ea5ff);
		color: #fff !important;
	}
	
	.top_header {
		justify-content: space-between;
		margin-bottom: 10px;
		background: #0F6EFF;
		width: 100%;
		margin: 0;
		border-radius: 0;
		color: #FFFFFF;
		height: 240px;
		.user_detail_wrap{
			position: fixed;
			    background: #0F6EFF;
			    width: 100%;
			    z-index: 10;
		}

		.user_detail {
			// width: 100%;
			padding: 28px 15px 15px 20px;
			top: 34px;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.user_header {
				width: 60px;
				height: 60px;
				overflow: hidden;
				border-radius: 50%;
				border: 3px solid rgba(255, 255, 255, 0.3);

				img {
					width: 100%;
					height: 100%;
				}
			}

			.user_name {
				margin-left: 3px;
				margin-top: 3px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;

				.user_all {
					// display: flex;
					// justify-content: flex-start;
					// align-items: center;

					.user_nickname {
						line-height: 21px;
						font-size: 18px;
						font-weight: bold;
						margin-top: 2px;
					}

					img {
						width: 22px;
						border-radius: 50%;
						margin-right: 3px;
					}

					.auth {
						justify-content: unset;
						margin-top: 3px;
					}

					.active {
						border: 2px solid #FFEB3B;
					}
				}
			}
		}

		.invite_code {
			margin-right: 30px;
			text-align: center;

			.invite_tips {
				margin-bottom: 10px;
			}

			.copy {
				justify-content: space-between;
				font-size: 16px;
				font-weight: bold;

				.copy_img {
					width: 14px;
					height: 14px;
					margin-left: 2px;
				}
			}

		}
		.invite_link_wrap{
			top: 105px;
			margin: 0 10%;
			position: relative;
			.invite_link{
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-size: 14px;
				font-weight: bold;
				.link{
					font-weight: 100;
				}
			}
			.copy_img {
				justify-content: space-between;
				width: 14px;
				height: 14px;
				margin-left: 2px;
			}
		}
		

		.user_earing {
			padding-bottom: 15px;
			text-align: center;
			position: relative;
			
			top: 115px;

			.today_earing {
				justify-content: space-around;

				.total_earing {
					p:nth-child(1) {
						font-size: 16px;
						font-weight: bold;
						margin-bottom: 8px;
						margin-top: 5px;
					}

					p:nth-child(2) {
						// color: #999;
					}
				}

				.today {
					p:nth-child(1) {
						font-size: 16px;
						font-weight: bold;
						margin-bottom: 8px;
						margin-top: 5px;
					}

					p:nth-child(2) {
						// color: #999;
					}
				}

				.yesterday {
					p:nth-child(1) {
						font-size: 16px;
						font-weight: bold;
						margin-bottom: 8px;
						margin-top: 5px;
					}

					p:nth-child(2) {
						// color: #999;
					}
				}
			}
		}
	}

	.my_team_wrap {
		margin-top: -50px;
		padding: 20px;
		margin-bottom: 10px;
		position: relative;
		    border: 1px solid #e4ecf9;
		    box-shadow: 0 10px 26px rgba(24, 61, 122, .08);
		background: #fff;
		    border-radius: 14px;
		    padding: 12px;

		.team_detail {
			justify-content: space-around;
			padding: 10px 0;

			div {
				text-align: center;

				p:nth-child(1) {
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 15px;

				}

				p:nth-child(2) {
					// color: #999;
				}
			}
		}

	}

	.report_wrap {
		margin-bottom: 20px;

		.report_item {
			margin-bottom: 10px;
			padding: 20px;
		}

		.title {
			padding: 0 0 15px 0px;
			font-size: 16px;
			border-bottom: 1px solid #F7F7F7;
		}

		.report_detail {
			justify-content: space-around;
			padding: 10px 0;


			div {
				text-align: center;

				p:nth-child(1) {
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 15px;
					margin-top: 5px;
					color: #3CB371;
				}

				p:nth-child(2) {
					// color: #999;
				}
			}
		}

	}
	.team_list_wrap{
		background: unset;
		box-shadow: unset;
		.team_list_title{
			padding: 15px 0 10px 3%;
			font-size: 16px;
		}
		.list_item {
		
			.item {
				box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
				padding: 20px;
				background: #FFFFFF;
				margin-bottom: 10px;
		
				div:nth-child(1) {
					margin-bottom: 20px;
					justify-content: space-between;
					border-bottom: 1px solid #ECECEC;
					padding-bottom: 15px;
					color: #999;
		
					p:nth-child(1) {
						text-align: left;
					}
		
					p:nth-child(2) {
						text-align: right;
					}
				}
		
				div:nth-child(2) {
					justify-content: space-between;
					margin-bottom: 10px;
					font-size: 14px;
		
					p:nth-child(1) {
						text-align: left;
						
					}
		
					p:nth-child(2) {
						text-align: right;
					}
				}
		
				div:nth-child(3) {
					justify-content: space-between;
					color: #999;
		
					p:nth-child(1) {
						
						text-align: right;
						
					}
		
					p:nth-child(2) {
						text-align: left;
						
					}
				}
		
			}
		
		}
	}

	.share_wrap {
		text-align: center;

		.share {
			margin-top: 6%;
		}

		.invite_code {
			margin: 10px 20px 20px 20px;
			justify-content: space-between;

			.code_link {
				color: #FF0000;
				font-weight: bold;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}

			.invite_link {
				max-width: 50%;
			}

			img {
				width: 16px;
				height: 16px;
			}
		}

		.invite_friend {
			padding: 10px;
			font-size: 16px;
			font-weight: bold;
		}

		.share_code {
			margin-bottom: 20px;
		}

		img {
			max-width: 60%;
		}
	}
	.share_btn{
		width: 50px;
		height: 50px;
		bottom: 73px;
	}

	.color999 {
		color: #999;
		font-size: 12px;
		margin-left: 5px;
	}
</style>
